const keys = {
    GET_COMMENTS: () => '/comments', // GET , type = course, post , id
    POST_COMMENT: '/comments', // POST  replay= parent_id , type = course , post , id , page_id , body string , rate 1-5
    PATCH_COMMENT: (id: string) => `/comments/${id}`, // body , rate , page_id
    DELETE_COMMENT: (id: string) => `/comments/${id}` // page_id
};

export default keys;

